<div id="sidebar-mobilemenu" class="" [ngClass]="(router.url.includes('home'))?'d-block d-sm-none':'d-none d-sm-block'">
    <div class="input-group my-2">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="icofont-search"></i></span>
      </div>
      <!-- <input type="text" class="form-control" placeholder="Search Events"> -->
      <input type="text" class="form-control" placeholder="Search Events" [(ngModel)]="selected"
        [ngModelOptions]="{standalone: true}" [typeahead]="searchData"
        [typeaheadItemTemplate]="customItemTemplate" [typeaheadScrollable]="true"
        [typeaheadOptionsInScrollableView]="5" typeaheadOptionField="name"
        (typeaheadOnSelect)="redirectSportDetail($event)">
        <ng-template #customItemTemplate let-model="item" let-index="index">
            <a href="javascript:void(0);" id="menu-link-redi" class="searchAnchor">
                {{model.name}}
            </a>
        </ng-template>
    </div>
    <div class="deposit_withdrawal" *ngIf="isLogin()">
        <a href="javascript:void(0)" routerLink="/deposit" class="deposit">
            <img src="http://speedcdn.io/assets/kesar-client/icons/deposit-icon.png"><span>Deposit</span>
        </a>
        <a href="javascript:void(0)" routerLink="/withdraw" class="withdraw">
            <img src="http://speedcdn.io/assets/kesar-client/icons/withdrawal-icon.png"><span>Withdrawal</span>
        </a>
    </div>
    <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
      <div class="menu-group">
        <h2>quick link</h2>
        <div class="panel panel-default">
            <div class="panel-heading" role="tab" id="headingOne">
                <a class="final-link" (click)="closeMSidebar()" href="javascript:void(0);" routerLink="/dashboard" routerLinkActive="active">
                    <i class="more-less icofont-curved-right"></i>
                    <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/stop-watch-sidebar.png">
                    inplay
                </a>
            </div>
        </div>
        <div class="panel panel-default" *ngIf="isLogin()">
            <div class="panel-heading" role="tab" id="headingOne">
                <a class="final-link" (click)="closeMSidebar()" href="javascript:void(0);" routerLink="/multi-market" routerLinkActive="active">
                    <i class="more-less icofont-curved-right"></i>
                    <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/stop-watch-sidebar.png">
                    multi market
                </a>
            </div>
        </div>
      </div>
      <div class="menu-group">
        <h2>Sports</h2>
        <div class="panel panel-default" *ngFor="let mn of menu;let i=index;trackBy:trackByIndex">
            <div class="panel-heading" role="tab" id="headingOne-{{i}}">
                <a href="javascript:void(0)" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne-{{i}}" aria-expanded="true" attr.aria-controls="collapseOne-{{i}}">
                    <i class="more-less icofont-curved-right"></i>
                    <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/{{mn.id}}.png">
                    {{mn?.name}}
                </a>
            </div>
            <div id="collapseOne-{{i}}" class="panel-collapse collapse" role="tabpanel" attr.aria-labelledby="headingOne-{{i}}">
                <div class="panel-body">
                      <!-- SPORTS LIST -->  
                      <ul *ngIf="mn.id != 7 && mn.id != 4339">
                        <li *ngFor="let item of mn.child;let j=index;trackBy:trackByIndex">
                            <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne-{{i}}{{j}}" aria-expanded="true" attr.aria-controls="collapseOne-{{i}}{{j}}">
                                <i class="more-less icofont-curved-right"></i>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/stop-watch-sidebar.png">
                                {{item.name}}
                            </a>
                            <div id="collapseOne-{{i}}{{j}}" class="panel-collapse collapse" role="tabpanel" attr.aria-labelledby="headingOne-{{i}}{{j}}">
                                <div class="panel-body">
                                      <ul>
                                        <li *ngFor="let item of item.data;let j=index;trackBy:trackByIndex">
                                            <a class="final-link" (click)="closeMSidebar()" routerLinkActive="active" href="javascript:void(0)" [routerLink]="['/event/detail',item.event_id]" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne-{{j}}" aria-expanded="true" attr.aria-controls="collapseOne-{{j}}">
                                                {{item.name}}
                                            </a>
                                        </li>
                                      </ul>
                                </div>
                            </div>
                        </li>
                      </ul>
                      <!-- RACE LIST -->
                      <ul *ngIf="mn.id == 7 || mn.id == 4339">
                        <li *ngFor="let item of mn.data;let j=index;trackBy:trackByIndex">
                            <a class="final-link" (click)="closeMSidebar()" routerLinkActive="active" href="javascript:void(0)" [routerLink]="['/event/detail',item.event_id, item?.market_id]">
                                {{item.event_name}} ({{item.market_start_time_format | date: 'hh:mm a'}})
                            </a>
                        </li>
                      </ul>
                </div>
            </div>
        </div>
        <h2>Casinos</h2>
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingOne">
              <a class="final-link" (click)="closeMSidebar()" href="javascript:void(0);" (click)="confirmSport(99999)" routerLinkActive="active">
                  <i class="more-less icofont-curved-right"></i>
                  <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/99999.png">
                  Casino
              </a>
          </div>
        </div>
        <div class="panel panel-default">
            <div class="panel-heading" role="tab" id="headingOne">
                <a class="final-link" (click)="closeMSidebar()" href="javascript:void(0);" (click)="confirmSport(99995)" routerLinkActive="active">
                    <i class="more-less icofont-curved-right"></i>
                    <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/99995.png">
                    I Casino
                </a>
            </div>
        </div>
    </div><!-- panel-group -->
  </div>